// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"TextArea__pc_only___1t_5s","sp_only":"TextArea__sp_only___1R17D","textarea":"TextArea__textarea___1vELj"};